/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import {
	ButtonProps,
	ElementProps,
	Button as NativeButton,
} from '@mantine/core';

// Styles
import classes from './Button.module.css';

// UI local components
import { Text } from '../Text';

/* -------------------------------------------------------------------------- */
/*                                  Interface                                 */
/* -------------------------------------------------------------------------- */
export interface IButtonProps
	extends
		ButtonProps,
		ElementProps<'button', keyof ButtonProps> {
	variant: 'primary' | 'outline' | 'transparent';
	children?: React.ReactNode;
}

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Button = (props: IButtonProps) => {
	/* ******************************** PROPS ******************************* */
	const { children, ...restProps } = props;

	/* ******************************** RENDERING ******************************* */
	return (
		<NativeButton
			classNames={classes}
			children={
				<Text
					variant={
						restProps?.variant == 'primary'
							? 'button'
							: 'body2'
					}
				>
					{children}
				</Text>
			}
			{...restProps}
		/>
	);
};
